{/* Auto-generated icon - do not edit */}
import React from 'react'

interface LocationPinIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const LocationPinIcon = React.forwardRef<SVGSVGElement, LocationPinIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 38 141"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M16.599 33.4326C15.5514 33.1077 14.801 32.9245 14.0863 32.647C12.1938 32.0309 10.3496 31.2751 8.56875 30.3858C2.04376 26.6484 -0.329446 20.063 2.13203 12.9779C5.29975 3.86093 13.2722 -0.875189 22.7741 0.751834C24.5202 1.05073 26.2463 1.47419 27.9775 1.85625C32.1371 2.77503 34.7932 5.33598 36.1622 9.33338C37.7181 13.7686 37.7956 18.5888 36.383 23.0718C35.8313 25.0627 34.7935 26.885 33.3633 28.3747C31.9331 29.8643 30.1552 30.9746 28.1897 31.6054C26.7376 32.1187 25.2505 32.532 23.4998 33.0785C23.4998 33.7932 23.4959 34.5378 23.4998 35.2876C23.6868 65.7297 23.8651 96.1727 24.0347 126.616C24.049 129.715 23.703 132.82 23.4505 135.916C23.361 136.794 23.1476 137.655 22.8169 138.473C22.5763 139.225 22.0795 139.868 21.4133 140.289C20.7472 140.711 19.9541 140.885 19.1728 140.781C18.4407 140.773 17.7325 140.519 17.1622 140.059C16.592 139.599 16.1928 138.961 16.0291 138.247C15.6634 136.97 15.4649 135.651 15.4384 134.323C15.5592 106.324 15.7149 78.3255 15.9058 50.3272C15.9434 45.4468 16.3601 40.5688 16.5938 35.689C16.6262 35.0314 16.599 34.3721 16.599 33.4326ZM29.279 17.0291C29.279 16.4748 29.3141 15.9185 29.2732 15.3675C28.9986 11.6755 27.4167 9.0493 23.5219 8.28127C21.0287 7.79005 18.5606 7.13618 16.0492 6.78661C15.082 6.72248 14.121 6.98258 13.3177 7.52553C10.6959 9.24872 9.27818 11.8661 8.42458 14.8174C7.26268 18.8368 8.40316 21.7827 12.0356 23.8002C13.6725 24.7389 15.4784 25.3451 17.3496 25.5842C19.2209 25.8234 21.121 25.6909 22.941 25.194C27.8795 23.9302 29.3335 22.1863 29.279 17.0291Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="37" height="141" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

LocationPinIcon.displayName = 'LocationPinIcon'
